"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListNavItemDefaultProps = exports.ListNavItem = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ListNavItem = function ListNavItem(props) {
  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      selected = props.selected,
      label = props.label,
      icon = props.icon,
      _onClick = props.onClick,
      NewProps = _objectWithoutProperties(props, ["children", "className", "disabled", "selected", "label", "icon", "onClick"]);

  var isClickable = !disabled && typeof _onClick !== 'undefined';
  var listNavItemClassName = (0, _classnames.default)('listnav-component__listnavitem', className, {
    'listnav-component__listnavitem--clickable': isClickable,
    'listnav-component__listnavitem--selected': selected,
    'listnav-component__listnavitem--disabled': disabled
  }); // ADA compliant - allow an enter key to act like a click.

  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  var additionalProps = disabled ? {} : {
    role: 'button',
    tabIndex: 0,
    onKeyDown: _handleKeyPress,
    onClick: function onClick(event) {
      if (isClickable && typeof _onClick !== 'undefined') {
        _onClick(event);
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: listNavItemClassName
  }, additionalProps, NewProps), typeof icon !== 'undefined' && /*#__PURE__*/_react.default.createElement("div", {
    className: "listnav-component__listnavitem__icon"
  }, icon), label ? /*#__PURE__*/_react.default.createElement("div", {
    className: "listnav-component__listnavitem__text"
  }, label) : children);
};

exports.ListNavItem = ListNavItem;
ListNavItem.propTypes = {
  className: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  selected: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func,
  icon: _propTypes.default.element,
  label: _propTypes.default.string,
  children: _propTypes.default.node
};
var ListNavItemDefaultProps = {
  className: '',
  disabled: false,
  selected: false
};
exports.ListNavItemDefaultProps = ListNavItemDefaultProps;
ListNavItem.defaultProps = ListNavItemDefaultProps;
var _default = ListNavItem;
exports.default = _default;